import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const UnauthenticatedRoute = () => {
    const auth = useAuth();
    const browserLocation = useLocation();

    if (auth.state.email) {
        const searchParams = new URLSearchParams(browserLocation.search);
        const target = searchParams.get('target');
        const navigateUrl = target ?? '/jobs';
        return <Navigate to={navigateUrl} />;
    }

    return <Outlet />;
};
